import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, pipe, share, tap } from 'rxjs';
import { ApiConstants } from '../../../constants/api-constants';
import { NameCode } from '../../../models/name-code';
import { CurriculumTrainingItemGroupsLookupRequest } from '../models/curriculum-training-item-groups-lookup-request';
import { UpdateTrainingItemGroupsRequest } from '../models/update-training-item-groups-request';
import { UpdateCurriculumsRequest } from '../models/update-curriculums-request';

@Injectable({
  providedIn: 'root'
})
export class CurriculumTrainingItemGroupManagementService {
  trainingItemGroups : NameCode[] = [];
  trainingItemGroupsObservable!:Observable<any>;
  curriculums : NameCode[] = [];
  curriculumsObservable!:Observable<any>;

  constructor(private httpClient : HttpClient) {
    
   }
   
   updateTrainingItemGroups(updateTrainingItemGroupsRequest: UpdateTrainingItemGroupsRequest) {
    return this.httpClient.post<string[]>(ApiConstants.TrainingItemGroup_Update, updateTrainingItemGroupsRequest);
  }

   getTrainingItemGroupsLookup(request : CurriculumTrainingItemGroupsLookupRequest) : Observable<NameCode[]>{
     let observable : Observable<NameCode[]>;
    if (this.trainingItemGroups.length > 0) {
      observable = of(this.trainingItemGroups);
    }else if(this.trainingItemGroupsObservable){
      observable = this.trainingItemGroupsObservable;
    }
    else {
      this.trainingItemGroupsObservable = this.httpClient.post<NameCode[]>(ApiConstants.TrainingItemGroup_LookUp, request)
        .pipe(
          tap(response => this.trainingItemGroups = response),
          share()
        );
        observable = this.trainingItemGroupsObservable;
    }
    return observable;
  }

   getCurriculumsLookup(request : CurriculumTrainingItemGroupsLookupRequest) : Observable<NameCode[]>{
     let observable : Observable<NameCode[]>;
    if (this.curriculums.length > 0) {
      observable = of(this.curriculums);
    }else if(this.curriculumsObservable){
      observable = this.curriculumsObservable;
    }
    else {
      this.curriculumsObservable = this.httpClient.post<NameCode[]>(ApiConstants.Curriculum_LookUp, request)
        .pipe(
          tap(response => this.curriculums = response),
          share()
        );
        observable = this.curriculumsObservable;
    }
    return observable;
  }
  updateCurriculums(updateCurriculumsRequest: UpdateCurriculumsRequest) { 
    return this.httpClient.post<string[]>(ApiConstants.Curriculum_Update, updateCurriculumsRequest);
  }
}
